import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { instagramIntegrationsQuery } from "modules/settings/lib/instagram/instagramIntegrationsQuery"
import { DataResponse, InstagramAuthorizeSchema, InstagramIntegrationsRespondeData } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof InstagramIntegrationsRespondeData>>

export function useCreateInstagramIntegrationMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.infer<typeof InstagramAuthorizeSchema>) => {
      const response = await axios.post<Response>(`/integrations/instagram/authorize`, data)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: instagramIntegrationsQuery().queryKey })
    },
  })
}
